import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthProvider>
    {/* <React.StrictMode> */}
      <ThemeProvider>
        <App />
      </ThemeProvider>
    {/* </React.StrictMode> */}
  </AuthProvider>

);
reportWebVitals();
